import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import swal from "sweetalert";


const Actions = ({ rowData, handleDeleteAdmin, handleChangeRoleToAdmin, isAdminMode, userRole }) => {
    const navigate = useNavigate();

    const swalChangeRoleHandeler = async (id) => {
      swal({
        title: "تبدیل کاربر به ادمین مورد تایید است؟",
        icon: "warning",
        buttons: {
          cancel: "بازگشت",
          yes: "بله",
        },
        dangerMode: true,
      }).then((isOk) => {
        if (isOk) {
          handleChangeRoleToAdmin(rowData.id);       
        }
      });
    }

    return (
        <span className="flex flex-row justify-center">
            {!isAdminMode ? (
                <>
                <Tooltip
                    title="ویرایش مشتری"
                    arrow={true}
                    placement="bottom"
                >
                    <IconButton
                        onClick={() => navigate("/users/add-user", {
                            state: rowData
                        })}
                    >
                        <EditIcon className="text-yellow-400" />
                    </IconButton>
                </Tooltip>
                <Tooltip
                    title="تبدیل به ادمین"
                    arrow={true}
                    placement="bottom"
                >
                    <IconButton
                        onClick={() => swalChangeRoleHandeler(rowData.id)}
                    >
                        <ManageAccountsIcon className="text-blue-500" />
                    </IconButton>
                </Tooltip>
                </>
            ) : userRole.id === 1 && (
                <Tooltip
                    title="ویرایش ادمین"
                    arrow={true}
                    placement="bottom"
                >
                    <IconButton
                        onClick={() => navigate("/users/add-user", {
                            state: rowData
                        })}
                    >
                        <EditIcon className="text-yellow-400" />
                    </IconButton>
                </Tooltip>
            )}
            {(isAdminMode && userRole.id === 1) && (
                <Tooltip
                    title="حذف ادمین"
                    arrow={true}
                    placement="bottom"
                >
                    <IconButton sx={{ mx: "0.25rem" }}
                        onClick={() => handleDeleteAdmin(rowData)}
                    >
                        <DeleteIcon className="text-red-400" />
                    </IconButton>
                </Tooltip>
            )}
        </span>
    );
}

export default Actions;
